import React from 'react'

import ErrorToast from '../../components/molecules/ErrorToast'

import { getMethods } from '../../lib/api'

type PaymentContextType = {
  methods: APIPaymentMethod[]
  loaded: boolean
  error: any
}

const PaymentContext = React.createContext<PaymentContextType>(null)

const PaymentProvider = ({ children }) => {
  const [methods, setMethods] = React.useState([])
  const [loaded, setLoaded] = React.useState(false)
  const [error, setError] = React.useState(null)

  // Load payment methods
  React.useEffect(() => {
    if (loaded) {
      return
    }

    getMethods()
      .then(methods => {
        setMethods(methods ?? [])
        setLoaded(true)
      })
      .catch(err => setError({ err, auto: true }))
  }, [loaded])

  return (
    <PaymentContext.Provider value={{ methods, loaded, error }}>
      {children}

      <ErrorToast error={error} />
    </PaymentContext.Provider>
  )
}

export default PaymentProvider

export const usePayment = () => React.useContext(PaymentContext)
